import { notifications } from "@mantine/notifications"

type NotifyOptions = {
  /** Secondary detail shown under the primary message */
  description?: string
}

export function notifySuccess(message: string) {
  notifications.show({
    message,
    color: "var(--color-on-surface-success)",
    autoClose: 4000,
  })
}

export function notifyError(message: string, options?: NotifyOptions) {
  const { description } = options ?? {}
  notifications.show({
    title: description ? message : undefined,
    message: description || message,
    color: "var(--color-on-surface-alert)",
    autoClose: 5000,
  })
}
